export const SET_ERR_MSG = 'SET_ERR_MSG';
export const REMOVE_ERR_MSG = 'REMOVE_ERR_MSG';
export const SET_BLOCK_ROUTE = 'SET_BLOCK_ROUTE';
